import { makeStyles } from "@material-ui/core/styles";

const playStepperStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		height: "100%"
	},
	button: {
		marginRight: theme.spacing(1)
	},
	completed: {
		display: "inline-block"
	},
	instructions: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1)
	},
	stepper: {
		backgroundColor: "transparent",
		padding: 0,
		flexWrap: "wrap"
	},
	stepLabel: {
		fontSize: 14,
		color: theme.palette.gameMode.secondary
	},
	stepButton: {
		marginTop: 0,
		marginBottom: 0,
		paddingTop: 0,
		paddingBottom: 0
	},
	stepButtonDisabled: {
		pointerEvents: "none",
		opacity: 0.3
	},
	stepLabelActive: {
		color: theme.palette.gameMode.primary
	}
}));

export default playStepperStyles;
